import { pageQuery } from "../pageQuery";

const l1ReviewEndpoints = {
  pending: "/compliance/l1-review",
  pendingPaged: (page: number, size: number) =>
    `/compliance/l1-review${pageQuery(page, size)}`,
  byId: (reviewId: string) => `/compliance/l1-review/${reviewId}`,
  byStatus: (status: string) => `/compliance/l1-review/by-status/${status}`,
  byStatusPaged: (status: string, page: number, size: number) =>
    `/compliance/l1-review/by-status/${status}${pageQuery(page, size)}`,
  authorize: (reviewId: string) =>
    `/compliance/l1-review/${reviewId}/authorize`,
  suspend: (reviewId: string) => `/compliance/l1-review/${reviewId}/suspend`,
  reject: (reviewId: string) => `/compliance/l1-review/${reviewId}/reject`,
  assign: (reviewId: string) => `/compliance/l1-review/${reviewId}/assign`,
  escalate: (reviewId: string) => `/compliance/l1-review/${reviewId}/escalate`,
  /** Correspondances a trancher, avec l'etat de chaque element de comparaison. */
  matches: (reviewId: string) => `/compliance/l1-review/${reviewId}/matches`,
  /** Ce qui a fait monter le risque : le pendant de `matches` quand la retenue vient du score. */
  riskFactors: (reviewId: string) =>
    `/compliance/l1-review/${reviewId}/risk-factors`,
  /** Jugement sur une correspondance : est-ce bien cette personne, ou non ? */
  qualifyMatch: (reviewId: string, matchId: string) =>
    `/compliance/l1-review/${reviewId}/matches/${encodeURIComponent(matchId)}/qualify`,
} as const;

export default l1ReviewEndpoints;
